/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import classNames from 'classnames';
import * as IconMapping from './ocpIconMapping.json';
import { trackPage } from '../../lib/analytics-helper';
import { doServerSideFptiCall, loadOcpFinalIntent, updateContextPromptClick } from './action-ocpComponent';
import { OMNI_CHANNEL_ARTICLE } from '../../home/constants/PropTypesShapes';
import i18n from '../../lib/reacti18n';
import Page from '../../lib/page';
import OmniPrompt from './OmniPrompt';
import { pathNames } from '../commonConstants';
import { CRAWL_INTENT_SEARCH_TOPIC } from '../../contactUs/constants/PropTypesShapes';

class OcpWidget extends Component {
  onOcpCardClickHandler(event, intentDummy, intentCode, searchTopicPool) {
    event.stopPropagation();
    // For contact Us
    if (this.props.pathName === pathNames.CONTACT_US) {
      return this.props.loadOcpFinalIntent(intentDummy, intentCode, searchTopicPool);
    }

    if (this.props.pathName === pathNames.HOME) {
      return this.props.updateContextPromptClick(intentDummy, intentCode);
    }

    return null;
  }

  // eslint-disable-next-line class-methods-use-this
  getContentLabel(labelPath) {
    return i18n.message(`smarthelp/ocpPrompts.${labelPath}`);
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  getOcpHeader(intents) {
    if (Page.isMobileLayout() || Page.isTabletLayout() || intents.length > 1) {
      return <span className="header-label">{this.getContentLabel('prefix')}</span>;
    }

    return null;
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  getIntentLabel(intents) {
    if (!Page.isMobileLayout() && !Page.isTabletLayout() && intents.length === 1) {
      return this.getContentLabel('prefix');
    }

    return '';
  }

  renderChannelSteeringWidget() {
    const { intentArticles, pathName, searchTopicPool } = this.props;

    const handleOcpIntentStyle = () =>
      classNames({
        'ocp-intents': pathName !== pathNames.HOME,
        [`ocp-intents-${pathName}`]: true,
      });

    const { intentArticleDetails } = intentArticles;
    try {
      trackPage({ id: `${pathName}OmniChannelPromptDisplayed` });
      return (
        <div className={handleOcpIntentStyle()}>
          <div className="ocp-container-top">
            {intentArticleDetails.map((cards) => {
              doServerSideFptiCall(cards);
              const intentCode = _get(cards, 'channelDetails.intentCode', '');
              return (
                <OmniPrompt
                  intentLabel={this.getContentLabel(intentCode)}
                  onClickHandler={(event) => this.onOcpCardClickHandler(event, cards, intentCode, searchTopicPool)}
                  intentCardIcon={`${IconMapping[intentCode]}`}
                  totalIntentsLength={intentArticleDetails.length}
                />
              );
            })}
          </div>
        </div>
      );
    } catch (e) {
      trackPage({ id: `${pathName}OmniChannelPromptError` });
      return <div />;
    }
  }

  render() {
    const { hideOmniChannelPrompt, intentArticles } = this.props;

    if (!hideOmniChannelPrompt && !_isEmpty(intentArticles)) {
      return this.renderChannelSteeringWidget();
    }

    // trackPage({ id: `${pathName}OmniChannelPromptNotDisplayed` });
    return <div />;
  }
}

OcpWidget.propTypes = {
  loadOcpFinalIntent: PropTypes.func.isRequired,
  hideOmniChannelPrompt: PropTypes.bool.isRequired,
  intentArticles: PropTypes.shape(OMNI_CHANNEL_ARTICLE),
  pathName: PropTypes.string.isRequired, // Supported pathNames: contactUs, home, miniHelp
  searchTopicPool: PropTypes.arrayOf(PropTypes.shape(CRAWL_INTENT_SEARCH_TOPIC)).isRequired,
  updateContextPromptClick: PropTypes.func.isRequired,
};

OcpWidget.defaultProps = {
  intentArticles: [],
};

function mapStateToProps(state) {
  return {
    intentArticles: state.ocp.omniIntents,
    hideOmniChannelPrompt: state.ocp.hideOmniChannelPrompt,
    searchTopicPool: state.crawlIntentTopic.searchTopicPool,
  };
}

function mapDispatchToProp(dispatch) {
  return bindActionCreators(
    {
      loadOcpFinalIntent,
      updateContextPromptClick,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProp)(OcpWidget);
